import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class IconsService {
  public tabName = new BehaviorSubject("");
  constructor() { }
}
